module.exports = __webpack_public_path__ + "img/occidental-kids.2546e77d.jpg";